<template>
  <filter-summary
    icon="store"
    title="店舗"
    :scroll-to-id="scrollToId"
    v-on="$listeners"
    :errors="errors"
    >{{ count }}店舗</filter-summary
  >
</template>

<script>
import FilterSummary from '@/components/FilterSummary.vue'

/**
 * 「店舗」の目次
 */
export default {
  components: { FilterSummary },
  props: {
    scrollToId: String,
    stores: {
      type: Array,
      default: () => [],
    },
    errors: {
      type: Array,
    },
  },
  computed: {
    count() {
      return this.stores.length
    },
    listeners() {
      return {
        ...this.$listeners,
      }
    },
  },
}
</script>
